import React from 'react';
import IProps from './interface';

interface IconDislikeProps extends Pick<IProps, 'className' | 'onClick'> {
  active?: boolean;
}

// [IMPORTANT] This component has two svg icons inside. So if you define props => be sure to pass them for both icons
const IconDislike = ({
  active = false,
  className,
  onClick,
}: IconDislikeProps) => {
  return active ? (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 13.428L12.351 18.179C11.672 19.064 10.346 19.086 9.637 18.225C9.372 17.904 9.228 17.5 9.228 17.084L9.228 13.813L6.132 13.813C5.531 13.813 4.97 13.513 4.636 13.014L4.307 12.523C4.012 12.082 3.926 11.533 4.073 11.024L5.432 6.302C5.654 5.531 6.359 5 7.161 5L13.45 5C13.95 5 14.428 5.208 14.768 5.574L16 6.9"
        fill="#D5E0F0"
      />
      <path
        d="M16 13.428L12.351 18.179C11.672 19.064 10.346 19.086 9.637 18.225V18.225C9.372 17.904 9.228 17.5 9.228 17.084L9.228 13.813L6.132 13.813C5.531 13.813 4.97 13.513 4.636 13.014L4.307 12.523C4.012 12.082 3.926 11.533 4.073 11.024L5.432 6.302C5.654 5.531 6.359 5 7.161 5L13.45 5C13.95 5 14.428 5.208 14.768 5.574L16 6.9"
        stroke="#2C66B1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.056 5L18.944 5C19.527 5 20 5.473 20 6.056L20 13.444C20 14.027 19.527 14.5 18.944 14.5L17.056 14.5C16.473 14.5 16 14.027 16 13.444L16 6.056C16 5.473 16.473 5 17.056 5Z"
        fill="#D5E0F0"
        stroke="#2C66B1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.056 5L18.944 5C19.527 5 20 5.473 20 6.056L20 13.444C20 14.027 19.527 14.5 18.944 14.5L17.056 14.5C16.473 14.5 16 14.027 16 13.444L16 6.056C16 5.473 16.473 5 17.056 5V5Z"
        stroke="#010E27"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 13.4281L12.351 18.1791C11.672 19.0641 10.346 19.0861 9.637 18.2251V18.2251C9.372 17.9041 9.228 17.5001 9.228 17.0841L9.228 13.8131L6.132 13.8131C5.531 13.8131 4.97 13.5131 4.636 13.0141L4.307 12.5231C4.012 12.0821 3.926 11.5331 4.073 11.0241L5.432 6.30206C5.654 5.53106 6.359 5.00006 7.161 5.00006L13.45 5.00006C13.95 5.00006 14.428 5.20806 14.768 5.57406L16 6.90006"
        stroke="#010E27"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconDislike;
